var map = {
	"./index.vue": [
		"4984",
		"view-calendar-_components-Calendar-newCalendar-vue",
		"view-Assignments-index-vue~view-index-vue~view-learningMaterials-_components-index-vue",
		"view-dashboard-_components-index-vue~view-index-vue~view-rolewise-dashboard-vue",
		"view-dashboard-_components-index-vue~view-index-vue",
		"view-index-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a301";
module.exports = webpackAsyncContext;